import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icons/home.png';
import _imports_1 from '@/assets/icons/arrowsRigth.png';
import _imports_2 from '@/assets/icons/price.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-24cbd23c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "productCategory" };
var _hoisted_2 = { class: "back" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/ _createTextVNode("您的位置 : ")
], -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("a", null, "首页", -1); });
var _hoisted_5 = { class: "productType" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("h3", null, "产品目录", -1); });
var _hoisted_7 = ["onClick"];
var _hoisted_8 = ["src"];
var _hoisted_9 = { class: "detalis_grop_padding" };
var _hoisted_10 = ["onClick"];
var _hoisted_11 = ["src"];
var _hoisted_12 = { class: "typeCard-body" };
var _hoisted_13 = ["onClick"];
var _hoisted_14 = { class: "typeCard-titleLink" };
var _hoisted_15 = { class: "typeCard-titleLinkLabel" };
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_1 }, null, -1); });
var _hoisted_17 = ["onClick", "innerHTML"];
var _hoisted_18 = { class: "selectButton" };
var _hoisted_19 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("a", null, [
        /*#__PURE__*/ _createElementVNode("span", null, "价格咨询"),
        /*#__PURE__*/ _createElementVNode("img", { src: _imports_2 })
    ])
], -1); });
var _hoisted_20 = [
    _hoisted_19
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_Nav = _resolveComponent("Nav");
    var _component_HomeJumbotron = _resolveComponent("HomeJumbotron");
    var _component_el_col = _resolveComponent("el-col");
    var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
    var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
    var _component_el_menu_item = _resolveComponent("el-menu-item");
    var _component_el_menu = _resolveComponent("el-menu");
    var _component_el_row = _resolveComponent("el-row");
    var _component_BasisGroup = _resolveComponent("BasisGroup");
    var _component_Dialog = _resolveComponent("Dialog");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Nav, { navActiveIndex: _ctx.navActiveIndex }, null, 8, ["navActiveIndex"]),
        _createVNode(_component_HomeJumbotron),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_row, null, {
                default: _withCtx(function () { return [
                    _createVNode(_component_el_col, {
                        md: 4,
                        xs: 1
                    }),
                    _createVNode(_component_el_col, {
                        md: 16,
                        xs: 22
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_breadcrumb_item, null, {
                                            default: _withCtx(function () { return [
                                                _hoisted_3
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_4
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_breadcrumb_item, null, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode("产品中心")
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_el_row, null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_col, {
                                            md: 6,
                                            xs: 1,
                                            class: "productTypeTiltle"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _hoisted_6,
                                                _createVNode(_component_el_menu, {
                                                    class: "menu-vertical",
                                                    "default-active": _ctx.selectProductId
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productTypeList, function (item) {
                                                            return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                                index: item.id,
                                                                key: item.id
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    _createElementVNode("a", {
                                                                        onClick: function ($event) { return (_ctx.selectProduct(item.id)); }
                                                                    }, [
                                                                        _createElementVNode("img", {
                                                                            src: item.img
                                                                        }, null, 8, _hoisted_8),
                                                                        _createTextVNode(" " + _toDisplayString(item.typeName), 1)
                                                                    ], 8, _hoisted_7)
                                                                ]; }),
                                                                _: 2
                                                            }, 1032, ["index"]));
                                                        }), 128))
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["default-active"])
                                            ]; }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                            md: 18,
                                            xs: 24,
                                            class: "principalPart"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createElementVNode("h2", null, _toDisplayString(_ctx.selectProductTypeName ? _ctx.selectProductTypeName : "力士乐导轨"), 1),
                                                _createElementVNode("div", _hoisted_9, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, function (item) {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            class: "details_group_box",
                                                            key: item.id
                                                        }, [
                                                            _createElementVNode("div", {
                                                                class: "details_group_card",
                                                                onClick: function ($event) { return (_ctx.JumpProductDetails(item)); }
                                                            }, [
                                                                _createElementVNode("p", null, [
                                                                    _createElementVNode("img", {
                                                                        class: "amplification-image",
                                                                        src: item.productImg
                                                                    }, null, 8, _hoisted_11)
                                                                ])
                                                            ], 8, _hoisted_10),
                                                            _createElementVNode("div", _hoisted_12, [
                                                                _createElementVNode("h4", {
                                                                    class: "utility-heading",
                                                                    onClick: function ($event) { return (_ctx.JumpProductDetails(item)); }
                                                                }, [
                                                                    _createElementVNode("a", _hoisted_14, [
                                                                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.productZhName), 1),
                                                                        _hoisted_16
                                                                    ])
                                                                ], 8, _hoisted_13),
                                                                (item.productDesc != null)
                                                                    ? (_openBlock(), _createElementBlock("p", {
                                                                        key: 0,
                                                                        style: { "cursor": "pointer" },
                                                                        onClick: function ($event) { return (_ctx.JumpProductDetails(item)); },
                                                                        class: "describe",
                                                                        innerHTML: item.productDesc.length > 100 ? item.productDesc.substring(0, 100) + '...' : item.productDesc.substring(0, item.productDesc.length - 1)
                                                                    }, null, 8, _hoisted_17))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("div", _hoisted_18, [
                                                                    _createElementVNode("p", {
                                                                        class: "inquirPrice",
                                                                        onClick: _cache[0] || (_cache[0] =
                                                                            //@ts-ignore
                                                                            function () {
                                                                                var args = [];
                                                                                for (var _i = 0; _i < arguments.length; _i++) {
                                                                                    args[_i] = arguments[_i];
                                                                                }
                                                                                return (_ctx.tipShow && _ctx.tipShow.apply(_ctx, args));
                                                                            })
                                                                    }, _hoisted_20)
                                                                ])
                                                            ])
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            })
        ]),
        _createVNode(_component_BasisGroup),
        _createVNode(_component_Dialog, {
            dialogVisible: _ctx.dialogVisible,
            onClose: _ctx.close
        }, null, 8, ["dialogVisible", "onClose"])
    ], 64));
}
